import styled from 'styled-components';

const ProductNotFoundText = styled.div`
  text-align: center;
  font-size: 20px;
  margin-top: 50px;
`;

export default ProductNotFoundText;
